import { c as _c } from "react/compiler-runtime";
import { SphereSupportLink } from "@components/common/sphere-support-link";
import { ContactSupportLocations } from "@custom-types/types";
import { Banner } from "@flat-ui";
import { Box } from "@mui-wrapper";
import { REQUEST_A_QUOTE_URL } from "@src/constants/subscription-constants";
import { DateTimeUtils } from "@stellar/utils";
import { topPriorityXgSubscriptionSelector } from "@store/sdb-company/sdb-company-selector";
import { useAppSelector } from "@store/store-helper";
import { nounPluralize } from "@utils/data-display";
import { OPEN_OTHERS_TARGET_ATTRIBUTE } from "@utils/project-utils";
import { isTrialSubscription } from "@utils/subscription-utils";
import { WorkspaceEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useCallback, useMemo, useState } from "react";

/** Default remaining days to start showing the banner */
const DEFAULT_DAYS = 3;
/** Banner to show when a trial subscription is about to expire */
export function TrialExpirationBanner(t0) {
  const $ = _c(16);
  const {
    days: t1
  } = t0;
  const days = t1 === undefined ? DEFAULT_DAYS : t1;
  const subscription = useAppSelector(topPriorityXgSubscriptionSelector);
  const {
    trackEvent
  } = useTrackEvent();
  const isTrial = isTrialSubscription(subscription);
  const [isDismissed, setIsDismissed] = useState(false);
  let t2;
  bb0: {
    const expirationDate = isTrial ? subscription?.endDate : undefined;
    if (!expirationDate) {
      t2 = days + 1;
      break bb0;
    }
    let t3;
    if ($[0] !== expirationDate) {
      t3 = DateTimeUtils.diffFromTodayInDays({
        date: expirationDate,
        shouldIncludeToday: false
      });
      $[0] = expirationDate;
      $[1] = t3;
    } else {
      t3 = $[1];
    }
    t2 = t3;
  }
  const remainingDays = t2;
  const name = subscription ? subscription.label : "trial";
  let t3;
  if ($[2] !== name || $[3] !== remainingDays) {
    t3 = remainingDays > 0 ? `Your ${name} subscription ends in ${nounPluralize({
      counter: remainingDays,
      word: "day"
    })}.` : `Your ${name} subscription has ended.`;
    $[2] = name;
    $[3] = remainingDays;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const description = t3;
  const shouldShowBanner = remainingDays <= days && isTrial && !isDismissed;
  let t4;
  if ($[5] !== trackEvent) {
    t4 = () => {
      trackEvent({
        name: WorkspaceEvents.requestAQuote
      });
      setIsDismissed(true);
      window.open(REQUEST_A_QUOTE_URL, OPEN_OTHERS_TARGET_ATTRIBUTE);
    };
    $[5] = trackEvent;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const onRequestAQuote = t4;
  if (!shouldShowBanner) {
    return null;
  }
  let t5;
  if ($[7] !== onRequestAQuote) {
    t5 = {
      label: "Request a quote",
      action: onRequestAQuote
    };
    $[7] = onRequestAQuote;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  let t6;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setIsDismissed(true);
    $[9] = t6;
  } else {
    t6 = $[9];
  }
  let t7;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <SphereSupportLink location={ContactSupportLocations.subscriptionExpiredBanner} />;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== description) {
    t8 = <div>{description} Request a quote or contact{" "}{t7}{" "}for further information.</div>;
    $[11] = description;
    $[12] = t8;
  } else {
    t8 = $[12];
  }
  let t9;
  if ($[13] !== t5 || $[14] !== t8) {
    t9 = <Box data-testid="trial-expiration-banner" component="div"><Banner variant="warning" action={t5} onClose={t6}>{t8}</Banner></Box>;
    $[13] = t5;
    $[14] = t8;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  return t9;
}